<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Relatório de Consumo</p>
    </div>

    <section>
      <component-superior
        subPrimeiro="Total consumo no período"
        :primeiro="
          highlights.ValorTotal
            ? formatarPreco(highlights.ValorTotal)
            : formatarPreco(0)
        "
        subSegundo="Número de produtos consumidos"
        :segundo="highlights.QuantidadeTotal"
        subTerceiro="Número de Vouchers"
        :terceiro="highlights.NumeroAtendimentos"
        subQuarto="Ticket médio por Atendimento"
        :quarto="
          highlights.TicketMedio
            ? formatarPreco(highlights.TicketMedio)
            : formatarPreco(0)
        "
      ></component-superior>
    </section>

    <section>
      <FiltrosComponent @emitirFiltros="getFiltros"></FiltrosComponent>
    </section>
    <div class="row q-mt-lg justify-end">
      <div>
        <q-checkbox
          v-model="simplificado"
          label="Simplificado"
          color="positive"
        />
      </div>
      <div class="q-ml-sm">
        <q-btn
          label="Exportar"
          color="secondary"
          icon="file_upload"
          no-caps
          @click="exportar"
        />
      </div>
    </div>
    <section class="q-mt-sm">
      <q-table
        flat
        title="Consumo"
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        dense
        :loading="disable"
        color="primary"
        :columns="columns"
        v-model:pagination="pagination"
        title-class="text-brand-5 text-weight-bold"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-url_assinada="props">
          <q-td>
            <q-btn
              :href="props.row.url_assinada"
              target="_blank"
              type="a"
              round
              color="primary"
              icon="file_download"
            />
          </q-td>
        </template>

        <template #body-cell-FinalizacaoData="props">
          <q-td>
            <span v-if="props.row.FinalizacaoData">{{
              props.row.FinalizacaoData.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>

            <span class="q-ml-sm" v-if="props.row.FinalizacaoData">{{
              props.row.FinalizacaoData.split(" ")[1]
            }}</span>
          </q-td>
        </template>

        <template #body-cell-epi="props">
          <q-td>
            <span v-if="props.row.ItemCaCodigo != null"
              ><q-icon name="done" size="sm" color="positive"
            /></span>
            <span v-else
              ><q-icon name="close" size="sm" color="negative"
            /></span>
          </q-td>
        </template>

        <template #body-cell-ItemPreco="props">
          <q-td>
            <span v-if="props.row.ItemPreco"
              >R$
              {{
                props.row.ItemPreco[6] != undefined
                  ? props.row.ItemPreco.slice(0, 6) +
                    "." +
                    props.row.ItemPreco[6]
                  : props.row.ItemPreco.slice(0, 6)
              }}</span
            >
            <span v-else>R$ 00,00</span>
          </q-td>
        </template>

        <template #body-cell-TotalItemVoucher="props">
          <q-td>
            <span v-if="props.row.TotalItemVoucher"
              >R$
              {{
                props.row.TotalItemVoucher[7] != undefined
                  ? props.row.TotalItemVoucher.slice(0, 7) +
                    "." +
                    props.row.TotalItemVoucher[7]
                  : props.row.TotalItemVoucher.slice(0, 6)
              }}</span
            >
            <span v-else>R$ 00,00</span>
          </q-td>
        </template>

        <template #body-cell-RequisicaoNumero="props">
          <q-td>
            <span class="link" @click="abrirNova(props.row.RequisicaoNumero)"
              >{{ props.row.RequisicaoNumero }}
            </span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "CentroCustoUnidade",
    label: "Unidade",
    field: "CentroCustoUnidade",
    align: "left",
  },
  {
    name: "CentroCustoCodigo",
    label: "Cód C/C	",
    field: "CentroCustoCodigo",
    align: "left",
  },
  {
    name: "CentroCustoNome",
    label: "Área",
    field: "CentroCustoNome",
    align: "left",
  },
  {
    name: "RequisicaoNumero",
    label: "Num Requisição	",
    field: "RequisicaoNumero",
    align: "left",
  },
  {
    name: "FinalizacaoData",
    label: "Finalização",
    field: "FinalizacaoData",
    align: "left",
  },
  {
    name: "SolicitanteNome",
    label: "Solicitante",
    field: "SolicitanteNome",
    align: "left",
  },
  {
    name: "ItemCodigo",
    label: "Cód Produto	",
    field: "ItemCodigo",
    align: "left",
  },
  {
    name: "ItemNomeContrato",
    label: "Produto",
    field: "ItemNomeContrato",
    align: "left",
  },
  {
    name: "epi",
    label: "EPI",
    field: "epi",
    align: "left",
  },
  {
    name: "ItemQuantidade",
    label: "QTDADE",
    field: "ItemQuantidade",
    align: "left",
  },
  {
    name: "ItemPreco",
    label: "Preço Unitario",
    field: "ItemPreco",
    align: "left",
  },
  {
    name: "TotalItemVoucher",
    label: "Total",
    field: "TotalItemVoucher",
    align: "left",
  },
];

import FiltrosComponent from "../components/filtrosConsumoComponent.vue";
import componentSuperior from "../components/componentSuperior.vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const router = useRouter();
    const simplificado = ref(false);
    const unidadeDefault = ref("");
    const highlights = ref({});
    const filtrosSave = ref();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 0, rowsPerPage = 15, filtros) => {
      quasar.loading.show();
      try {
        let response = await store.dispatch("ind/getConsumo", {
          entrega_unidade_id:
            filtros && filtros.unidade
              ? filtros.unidade.id
              : unidadeDefault.value.id,
          regiao: filtros && filtros.regiao ? filtros.regiao : undefined,
          dataInicial: filtros && filtros.inicial ? filtros.inicial : undefined,
          dataFinal: filtros && filtros.final ? filtros.final : undefined,
          item: filtros && filtros.produto ? filtros.produto : undefined,
          solicitante:
            filtros && filtros.solicitante ? filtros.solicitante : undefined,
          centroCusto: filtros && filtros.centro ? filtros.centro : undefined,
          epi: filtros && filtros.material ? filtros.material.value : undefined,
          voucher_id: filtros && filtros.id ? filtros.id : undefined,
          categoria_produto_codigo:
            filtros && filtros.categoria_produto_codigo
              ? filtros.categoria_produto_codigo
              : undefined,
          grupo_produto_nome:
            filtros && filtros.grupo_produto_nome
              ? filtros.grupo_produto_nome
              : undefined,
          page: page,
          perPage: rowsPerPage,
        });

        rows.value = response.data.return.data;
        highlights.value = response.data.return.highlights;
        highlights.value.ValorTotal = Number(
          highlights.value.ValorTotal
        ).toFixed(2);
        highlights.value.QuantidadeTotal = Number(
          highlights.value.QuantidadeTotal
        ).toFixed(2);
        highlights.value.NumeroAtendimentos = Number(
          highlights.value.NumeroAtendimentos
        ).toFixed(2);
        highlights.value.TicketMedio = Number(
          highlights.value.TicketMedio
        ).toFixed(2);
        pagination.value.rowsPerPage = response.data.return.per_page;
        pagination.value.rowsNumber = response.data.return.total;
        pagination.value.page = response.data.return.current_page;
        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("ind/exportarConsumo", {
          entrega_unidade_id: unidadeDefault.value.id,
          regiao:
            filtrosSave.value && filtrosSave.value.regiao
              ? filtrosSave.value.regiao
              : undefined,
          simplificado: simplificado.value ? 1 : undefined,
          grupo_produto_nome: 
            filtrosSave.value && filtrosSave.value.grupo_produto_nome
              ? filtrosSave.value.grupo_produto_nome
              : undefined,
          dataInicial:
            filtrosSave.value && filtrosSave.value.inicial
              ? filtrosSave.value.inicial
              : undefined,
          dataFinal:
            filtrosSave.value && filtrosSave.value.final
              ? filtrosSave.value.final
              : undefined,
          item:
            filtrosSave.value && filtrosSave.value.produto
              ? filtrosSave.value.produto
              : undefined,
          solicitante:
            filtrosSave.value && filtrosSave.value.solicitante
              ? filtrosSave.value.solicitante
              : undefined,
          centroCusto:
            filtrosSave.value && filtrosSave.value.centro
              ? filtrosSave.value.centro
              : undefined,
          epi:
            filtrosSave.value && filtrosSave.value.material
              ? filtrosSave.value.material.value
              : undefined,
          voucher_id:
            filtrosSave.value && filtrosSave.value.id
              ? filtrosSave.value.id
              : undefined,
          page: pagination.value.page,
          perPage: pagination.value.rowsPerPage,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = store.state.org.unidadeData;
    };
    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(
        pagination.value.page,
        pagination.value.rowsPerPage,
        filtrosSave.value
      );
    };

    const getFiltros = async (filtros) => {
      filtrosSave.value = filtros;
      getDados(1, pagination.value.rowsPerPage, filtrosSave.value);
    };

    const abrirNova = async (id) => {
      const routeData = router.resolve({
        name: "requisicao-detalhe",
        params: { requisicaoId: id },
      });
      window.open(routeData.href, "_blank");
    };

    const formatarPreco = (valor) => {
      if (valor == null || valor === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(parseFloat(valor));
    };

    const formatarInteiro = (valor) => {
      if (valor == null || valor === undefined) return "0";
      return Math.floor(parseFloat(valor)).toLocaleString("pt-BR");
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
        getDados();
      }
    );

    return {
      rows,
      columns,
      pagination,
      formatarPreco,
      formatarInteiro,
      disable,
      getDados,
      handleRequest,
      exportar,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getFiltros,
      highlights,
      abrirNova,
      simplificado,
    };
  },
  components: { FiltrosComponent, componentSuperior },
};
</script>

<style>
.link {
  color: #31ccec;
  cursor: pointer;
}

.q-table__top {
  padding: 12px 0px !important;
}
</style>
